<template>
  <div class="layout">
    <div class="menu">
      <Menu topIndex="fullSearch"></Menu>
    </div>
    <div id="searchAllBox">
      <div id="searchInput">
        <el-form
          label-width="110px"
          ref="searchFileForm"
          :model="searchFileForm"
        >
          <el-form-item label="全文检索：" style="width: 100%">
            <el-input
              v-model="searchContent"
              placeholder="请输入检索内容"
            ></el-input>
          </el-form-item>
          <el-form-item label="类型：">
            <el-select v-model="searchFileForm.type" clearable>
              <el-option
                v-for="item in typeList"
                :key="item.code"
                :value="item.value"
                :label="item.label"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="资源库：">
            <!-- <el-input
              v-model="searchFileForm.innerCode"
              placeholder="请输入资源库内码"
            ></el-input> -->
            <el-select v-model="selectedValue" clearable>
              <!-- :default-checked-keys="[editAPIForm.innerCodes]" -->
              <el-option :value="dataList"
                ><el-tree
                  ref="editTree"
                  :props="props"
                  :load="loadNode"
                  :check-on-click-node="true"
                  @check-change="handleCheckChange"
                  highlight-current
                  node-key="innerCode"
                  lazy
                >
                </el-tree>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="资源标题：">
            <el-input
              v-model="searchFileForm.name"
              placeholder="请输入条目名称/图片标题/音视频标题"
              @clear="clearName()"
              @input="change($event)"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="资源ID：">
            <el-input
              v-model="searchFileForm.id"
              placeholder="请输入资源ID"
            ></el-input>
          </el-form-item>
          <el-form-item label="安全级别：">
            <el-select v-model="searchFileForm.securityLevel" clearable>
              <el-option value="10" label="低"> </el-option>
              <el-option value="20" label="中"> </el-option>
              <el-option value="30" label="高"> </el-option>
              <el-option value="40" label="最高"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="searchFileForm.status" clearable>
              <el-option value="10" label="下架"> </el-option>
              <el-option value="20" label="上架"> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div id="addSearchTerm">
          <el-form label-width="110px" ref="addAttributeForm">
            <template v-for="(item, index) in addAttributeForm">
              <el-form-item :key="index.attrName" label="属性：">
                <el-select v-model="item.attrName" clearable>
                  <el-option
                    v-for="item in attrList"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :key="index.attrName" label="条件：">
                <el-select v-model="item.attrType" clearable>
                  <el-option
                    v-for="item in attrTypeList"
                    :key="item.value"
                    :value="item.value"
                    :label="item.label"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :key="index.attrName" label="内容：">
                <el-input
                  v-model="item.attrValue"
                  placeholder="请输入搜索内容"
                ></el-input>
              </el-form-item>
              <el-form-item :key="index.attrName" label="合并方式：">
                <el-select v-model="item.attrMerge" clearable>
                  <el-option
                    v-for="i in attrMergeList"
                    :key="i.value"
                    :value="i.value"
                    :label="i.label"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                :key="index"
                style="width: 11.2%; text-align: left; margin-right: 0"
                label-width="0"
                v-if="index != 0"
              >
                <el-button
                  type="primary"
                  size="mini"
                  class="searchTermButton"
                  style="color: #8fbc8f; border-color: #8fbc8f"
                  icon="el-icon-minus"
                  @click="deleteSearchTerm(index)"
                ></el-button>
              </el-form-item>
              <el-form-item
                :key="index"
                style="width: 11.2%; text-align: left; margin-right: 0"
                label-width="0"
                v-if="index == 0"
              >
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-plus "
                  class="searchTermButton"
                  @click="addSearchTerm()"
                ></el-button>
              </el-form-item>
            </template>
          </el-form>
        </div>

        <!-- <div id="addSearchList">
          <div v-for="item in attributeDataShow" :key="item.index">
            <div class="attributeContentBox">
              <span class="attributeName">属性：</span>
              <span class="attributeContent"> {{ item.attrName }}</span>
            </div>
            <div class="attributeContentBox">
              <span class="attributeName">检索方式：</span>
              <span class="attributeContent"> {{ item.attrType }}</span>
            </div>
            <div class="attributeContentBox">
              <span class="attributeName">关键词：</span>
              <span class="attributeContent"> {{ item.attrValue }}</span>
            </div>
            <div class="attributeContentBox">
              <span class="attributeName">合并方式：</span>
              <span class="attributeContent"> {{ item.attrMerge }}</span>
            </div>
            <div class="attributeContentBox" style="width: 11.2%">
              <el-button
                type="primary"
                size="mini"
                style="margin-left: 20px"
                icon="el-icon-close "
                @click="deleteSearchTerm(item.index)"
                >删除</el-button
              >
            </div>
          </div>
        </div> -->
        <div class="fullSearchButtonBox">
          <el-button
            type="primary"
            size="mini"
            style="margin-left: 20px"
            icon="el-icon-search"
            @click="
              currentPage = 1;
              onSearch();
            "
            >查询</el-button
          >
          <el-button
            type="primary"
            size="mini"
            style="margin-left: 20px"
            icon="el-icon-download"
            @click="SourceOut()"
            >元数据导出</el-button
          >
        </div>
      </div>
      <!-- <div id="recMessage">Hello World!</div> -->
      <div id="searchResult">
        <el-table
          :data="resultTableData"
          v-loading="tableLoading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-customClass="loadingStyles"
          style="width: 100%"
          class="maintable"
          border
          :header-cell-style="{ background: '#f8f8f8' }"
        >
          <el-table-column type="index" min-width="50" align="center">
          </el-table-column
          ><el-table-column
            prop="name"
            show-overflow-tooltip
            min-width="80"
            label="名称"
            align="center"
          >
            <template slot-scope="scope">
              <span v-html="scope.row.name"></span>
              <!-- 这里使用 v-html 插入 HTML -->
            </template></el-table-column
          >
          <el-table-column
            prop="sourceName"
            show-overflow-tooltip
            min-width="80"
            label="来源"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="status"
            show-overflow-tooltip
            min-width="80"
            label="状态"
            align="center"
          >
            <template slot-scope="scope">
              <span effect="dark" v-if="scope.row.status == 10">未上架</span>
              <span effect="dark" v-if="scope.row.status == 20">已上架</span>
            </template></el-table-column
          >
          <el-table-column
            prop="type"
            show-overflow-tooltip
            min-width="80"
            label="类型"
            align="center"
          >
            <template slot-scope="scope">
              <span effect="dark" v-if="scope.row.type == 10">百科条目</span>
              <span effect="dark" v-if="scope.row.type == 20">辞典工具书</span>
              <span effect="dark" v-if="scope.row.type == 30">专项数据</span>
              <span effect="dark" v-if="scope.row.type == 40">图书</span>
              <span effect="dark" v-if="scope.row.type == 50">图片</span>
              <span effect="dark" v-if="scope.row.type == 60">音频</span>
              <span effect="dark" v-if="scope.row.type == 70">视频</span>
              <span effect="dark" v-if="scope.row.type == 80">图片集</span>
              <span effect="dark" v-if="scope.row.type == 90">音频集</span>
              <span effect="dark" v-if="scope.row.type == 100">视频集</span>
              <span effect="dark" v-if="scope.row.type == 110">3D动画</span>
              <span effect="dark" v-if="scope.row.type == 120">论文</span>
              <span effect="dark" v-if="scope.row.type == 130">文章</span>
              <span effect="dark" v-if="scope.row.type == 140">问答对</span>
            </template></el-table-column
          >
          <el-table-column
            prop="securityLevel"
            show-overflow-tooltip
            min-width="80"
            label="安全级别"
            align="center"
          >
            <template slot-scope="scope">
              <span effect="dark" v-if="scope.row.securityLevel == 10">低</span>
              <span effect="dark" v-if="scope.row.securityLevel == 20">中</span>
              <span effect="dark" v-if="scope.row.securityLevel == 30">高</span>
              <span effect="dark" v-if="scope.row.securityLevel == 40"
                >最高</span
              >
            </template></el-table-column
          >
          <el-table-column show-overflow-tooltip label="操作" align="center">
            <template slot-scope="scope">
              <span
                class="right-add-button"
                style="display: block"
                @click="preview(scope.row)"
                >【预览】</span
              >
            </template>
          </el-table-column></el-table
        >
        <!-- 列表分页 -->
        <div class="pagination-box">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalSize"
          >
          </el-pagination>
        </div>
      </div>

      <!-- 元数据导出弹窗 -->
      <el-dialog title="元数据导出" :visible.sync="outDialog" width="600px">
        <el-form>
          <el-form-item label="导出字段：">
            <el-select
              v-model="exportForm.exportTitles"
              clearable
              multiple
              collapse-tags
              placeholder="请选择导出列表字段"
            >
              <el-option
                v-for="item in exportTitlesList"
                :key="item.value"
                :value="item.value"
                :label="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="toExport()">确 定</el-button>
          <el-button @click="outDialog = false">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 导出过程提示弹窗 -->
      <el-dialog title="导出" 
        :visible.sync="processDialog" 
        :close-on-click-modal="false" 
        width="600px">
        <p>数据导出中，请稍后……</p>
      </el-dialog>
      <!-- 导出xml数据包弹窗 -->
      <el-dialog
        title="导出xml数据包"
        :visible.sync="listOutDialog"
        width="800px"
      >
        <el-form
          ref="exportDataListForm"
          :model="exportDataListForm"
          :rules="exportDataListRules"
          label-width="140px"
        >
          <el-form-item label="是否导出资源:" prop="isExportResource">
            <el-select v-model="exportDataListForm.isExportResource">
              <el-option value="10" label="否"></el-option>
              <el-option value="20" label="是"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="exportDataListForm.isExportResource == '20'"
            label="是否导出水印:"
            prop="isExportWatermark"
          >
            <el-select v-model="exportDataListForm.isExportWatermark">
              <el-option value="10" label="否"></el-option>
              <el-option value="20" label="是"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            label="是否导出原始资源:"
            prop="isExportSourceResource"
            v-if="exportDataListForm.isExportResource == '20'"
          >
            <el-select v-model="exportDataListForm.isExportSourceResource">
              <el-option value="10" label="否"></el-option>
              <el-option value="20" label="是"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="导出用户:">
            <el-input
              type="text"
              v-model="exportDataListForm.expUser"
              placeholder="请填写导出用户"
            ></el-input>
          </el-form-item>
          <el-form-item label="用途:">
            <el-input
              type="text"
              v-model="exportDataListForm.expYt"
              placeholder="请填写用途"
            ></el-input>
          </el-form-item>
          <el-form-item label="使用人员:">
            <el-input
              type="text"
              v-model="exportDataListForm.toUser"
              placeholder="请填写使用人员"
            ></el-input>
          </el-form-item>
          <el-form-item label="使用部门:">
            <el-input
              type="text"
              v-model="exportDataListForm.toDept"
              placeholder="请填写使用部门"
            ></el-input>
          </el-form-item>
          <el-form-item label="审核意见:">
            <el-input
              type="text"
              v-model="exportDataListForm.expAudit"
              placeholder="请填写审核意见"
            ></el-input>
          </el-form-item>
          <el-form-item label="导出时间:">
            <el-date-picker
              v-model="exportDataListForm.expTime"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="exportDataList()">确 定</el-button>
          <el-button @click="listOutDialog = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Menu from "../menu/menu.vue";
import $ from "jquery";
import cookies from "vue-cookies";
export default {
  data: function () {
    return {
      exportTitlesList: [],
      tableLoading: false,
      tagSearchflag: true,
      searchContent: "",
      searchFileForm: {},
      exportDataListForm: {},
      sourceOutFalse: false,
      addAttributeForm: [
        {
          attrName: "",
          attrValue: "",
          attrType: "",
          attrMerge: 10,
        },
      ],
      attributeData: [],
      attributeDataShow: [],
      attrList: [
        {
          label: "拼音条头",
          value: "zhName",
        },
        {
          label: "英文条头",
          value: "enName",
        },
        {
          label: "拉丁文",
          value: "latinName",
        },
        {
          label: "外文条头",
          value: "foreignName",
        },
        {
          label: "原语种名称",
          value: "firstName",
        },
        {
          label: "学科行业标签",
          value: "subjectTag",
        },
        {
          label: "条目标签",
          value: "tags",
        },
        {
          label: "标签（包含学科行业标签及条目标签）",
          value: "tag",
        },
        {
          label: "分支路径",
          value: "subBranch",
        },
        {
          label: "正文",
          value: "contentText",
        },
        {
          label: "定性语",
          value: "descText",
        },
        {
          label: "摘要key",
          value: "summaryKey",
        },
        {
          label: "摘要value",
          value: "summaryValue",
        },
        {
          label: "操作备注",
          value: "remark",
        },
        {
          label: "资源历史ID",
          value: "oldId",
        },
        {
          label: "多媒体来源",
          value: "meidaOrigin",
        },
        {
          label: "多媒体来源方式",
          value: "meidaDealtype",
        },
        {
          label: "资源模式",
          value: "mediaMode",
        },
        {
          label: "著作权",
          value: "mediaCopyright",
        },
        {
          label: "内容类别",
          value: "mediaContentType",
        },
        {
          label: "合同",
          value: "mediaContract",
        },
        {
          label: "许可类型",
          value: "mediaPermitType",
        },
        {
          label: "许可范围",
          value: "mediaPermitScope",
        },
        {
          label: "许可范围",
          value: "mediaPermitTime",
        },
        {
          label: "资源类型",
          value: "mediaResourceType",
        },
        {
          label: "关联条目名称",
          value: "linkWordName",
        },
        {
          label: "关联条目分支路径",
          value: "linkWordSubjectBranch",
        },
        {
          label: "是否包含图片",
          value: "isImg",
        },
        {
          label: "是否包含音频",
          value: "isAudio",
        },
        {
          label: "是否包含视频",
          value: "isVideo",
        },
        {
          label: "扩展阅读",
          value: "extendText",
        },
        {
          label: "参考文献",
          value: "refText",
        },
        {
          label: "本人著作",
          value: "opusText",
        },
        {
          label: "关键词",
          value: "wordText",
        },
      ],
      attrNameArry: [],
      attrTypeList: [
        {
          label: "等于",
          value: 10,
        },
        {
          label: "包含",
          value: 20,
        },
        {
          label: "不包含",
          value: 30,
        },
        {
          label: "空",
          value: 40,
        },
        {
          label: "非空",
          value: 50,
        },
      ],
      attrMergeList: [
        {
          label: "并且",
          value: 10,
        },
        {
          label: "或者",
          value: 20,
        },
      ],
      typeList: [
        {
          label: "百科条目",
          value: 10,
        },
        {
          label: "辞典工具书",
          value: 20,
        },
        {
          label: "专项数据",
          value: 30,
        },
        {
          label: "图书",
          value: 40,
        },
        {
          label: "图片",
          value: 50,
        },
        {
          label: "音频",
          value: 60,
        },
        {
          label: "视频",
          value: 70,
        },
        {
          label: "图片集",
          value: 80,
        },
        {
          label: "音频集",
          value: 90,
        },
        {
          label: "图书",
          value: 30,
        },
        {
          label: "视频集",
          value: 100,
        },
        {
          label: "3D动画",
          value: 110,
        },
        {
          label: "论文",
          value: 120,
        },
        {
          label: "文章",
          value: 130,
        },
        {
          label: "问答对",
          value: 140,
        },
      ],
      resultTableData: [],
      dataList: [],
      props: {
        label: "name",
        children: "children",
        isLeaf: "leaf",
      },
      selectedValue: "",
      currentPage: 1,
      resultName: "",
      pageSize: 10,
      totalSize: 0,
      outDialog: false,
      listOutDialog: false,
      processDialog: false,

      exportForm: {},
      exportDataListRules: {
        isExportWatermark: [
          { required: true, message: "请选择请选择", trigger: "blur" },
        ],
        isExportResource: [
          { required: true, message: "请选择是否导出资源", trigger: "blur" },
        ],
        isExportSourceResource: [
          {
            required: true,
            message: "请选择是否导出原始资源",
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
    Menu,
  },
  mounted() {
    var currentToken = cookies.get("token");
    $.ajaxSetup({
      headers: {
        AuthorizationToken: currentToken,
      },
    });
    var tagSearch = window.location.search;
    if (tagSearch != "") {
      this.onSearch();
    } else {
      this.searchParam();
    }
    // window.addEventListener("message", this.receiveMessage);
  },
  methods: {
    // receiveMessage(event) {
    //   if (event.origin !== "http://localhost:9999") {
    //     // 验证消息来源
    //     return;
    //   }
    //   var messageEle = document.getElementById("recMessage");
    //   messageEle.innerHTML = event.data;
    //   localStorage.setItem("currentToken", event.data);
    //   // console.log("Received message:", event.data);
    //   // 处理接收到的消息
    // },
    beforeDestroy() {
      window.removeEventListener("message", this.receiveMessage);
    },
    onSearch() {
      var that = this;
      if (this.tagSearchflag) {
        var tagSearch = window.location.search;
        if (tagSearch != "") {
          that.searchFileForm.name = decodeURI(tagSearch.split("=")[1]);
        }
        this.searchParam();
        that.tagSearchflag = false;
      } else {
        this.searchParam();
      }
    },
    // 树形结构加载
    loadNode(node, resolve) {
      let that = this;
      $.ajax({
        url: "/zyk/c/subject/subjectInfo/list?page=1&size=1000",
        type: "GET",
        headers: {
          AuthorizationToken: cookies.get("token"),
        },
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          if (node.level == 0) {
            this.treeNode_had = node;
            that.dataList = data.obj.list;
            return resolve(that.dataList);
          } else {
            $.ajax({
              url: "/zyk/c/subject/subjectInfo/list?page=1&size=1000",
              type: "GET",
              //contentType: 'application/json;charset=utf-8',
              data: { id: node.data.id },
              dataType: "json",
              error: function (xhr) {
                if (xhr.status == 401) {
                  window.location.reload();
                }
              },
              success: function (data) {
                return resolve(data.obj.list);
              },
            });
          }
        },
      });
    },
    // 加载数据
    searchParam() {
      let that = this;
      let params = {};
      if (this.searchFileForm.length != 0) {
        params = this.searchFileForm;
      }
      if (this.searchContent != "") {
        params.content = this.searchContent;
      }else{
        params.content = "";
      }
      if (this.selectedValue == "") {
        params.innerCode = "";
      }      
      params.attributeList = this.addAttributeForm;
      that.tableLoading = true;
      $.ajax({
        type: "POST",
        dataType: "json",
        url: "/zyk/es/highLevel/search",
        data: {
          json: JSON.stringify(params),
          size: this.pageSize,
          page: this.currentPage,
        },
        // contentType: "application/json;charset=utf-8",
        success: function (response) {
          if (response.code == 200) {
            that.optionData = response.obj.list;
            if (response.obj.list && response.obj.list.length == 0) {
              that.dataText = "暂无数据";
            }
            that.tableLoading = false;
            that.totalSize = response.obj.total;
            that.resultTableData = response.obj.list;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.searchParam();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchParam();
    },
    preview(row) {
      if (row.type == 10) {
        var downloadA = document.createElement("a");
        downloadA.href = "/preview?id=" + row.id;
        downloadA.target = "_blank";
        downloadA.click();
      } else if (row.type == 50 || row.type == 60 || row.type == 70) {
        var downloadM = document.createElement("a");
        downloadM.href = "/mediaPreview?id=" + row.id;
        downloadM.target = "_blank";
        downloadM.click();
      } else if (row.type == 140) {
        var downloadQ = document.createElement("a");
        downloadQ.href = "/qaPreview?id=" + row.id;
        downloadQ.target = "_blank";
        downloadQ.click();
      }
    },
    addSearchTerm() {
      this.addAttributeForm.push({
        attrName: "",
        attrValue: "",
        attrType: "",
        attrMerge: 10,
      });
    },
    deleteSearchTerm(index) {
      let that = this;
      that.addAttributeForm = this.addAttributeForm.filter(
        (item, i) => i != index
      );
    },
    handleCheckChange() {
      let that = this;
      this.selectedValue = this.$refs.editTree.getCurrentNode().name;
      that.searchFileForm.innerCode =
        this.$refs.editTree.getCurrentNode().innerCode;
    },
    clearName() {
      var that = this;
      that.searchFileForm.name = "";
      that.tagSearchflag = false;
      this.$refs["searchFileForm"].resetFields();
    },
    change() {
      this.$forceUpdate();
    },
    // 元数据导出
    SourceOut() {
      var that = this;
      that.exportTitlesList = [];
      let params = {};
      if (this.searchFileForm.length != 0) {
        params = this.searchFileForm;
      }
      if (this.searchContent != "") {
        params.content = this.searchContent;
      }
      params.attributeList = this.addAttributeForm;
      that.exportForm.json = JSON.stringify(params);
      that.exportForm.exportKey = "ES";
      delete that.exportForm.exportTitles;
      this.outDialog = true;
      $.ajax({
        url: "/zyk/a/exportList",
        type: "GET",
        //contentType: 'application/json;charset=utf-8',
        data: that.exportForm,
        dataType: "json",
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          var tagData = data.obj;
          for (var i = 0; i < tagData.length; i++) {
            that.exportTitlesList.push({
              value: tagData[i],
            });
          }
        },
      });
    },
    // 列表导出确认
    toExport() {
      var that = this;
      that.exportForm.exportTitles = this.exportForm.exportTitles.toString();
      var downloadA = document.createElement("a");
      this.outDialog = false;
      this.processDialog = true;
      $.ajax({
        url: "/zyk/a/exportList",
        type: "GET",
        //contentType: 'application/json;charset=utf-8',
        data: this.exportForm,
        dataType: "json",
        error: function (xhr) {
          console.log(xhr);
        },
        success: function (data) {
          if (data.code == 200) {
            downloadA.href = data.obj;
            downloadA.download;
            downloadA.click();
            that.processDialog = false;
          }else{
            that.processDialog = false;
            that.$message({
              message: data.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
      });
    },
  },
};
</script>

<style>
#searchAllBox {
  margin-top: 97px;
  padding: 10px 5%;
}

#searchResult {
  margin-top: 50px;
  font-family: "DBKai";
}

#searchInput .el-form-item {
  width: 33.3%;
  margin-bottom: 0;
}

#addSearchTerm .el-form-item,
#addSearchList .el-form-item {
  width: 22.2%;
}

#searchInput .el-select {
  width: 100%;
}

#addSearchList {
  overflow: auto;
  margin-top: 20px;
}

#addSearchList::after {
  content: "";
  display: inline-block;
  clear: both;
}

#addSearchList .attributeContentBox {
  width: 22.2%;
  float: left;
  margin-bottom: 20px;
}

#addSearchList .attributeContentBox span {
  display: block;
}

#addSearchList .attributeContentBox .attributeName {
  width: 110px;
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}

#addSearchList .attributeContentBox .attributeContent {
  line-height: 40px;
  position: relative;
  font-size: 14px;
  margin-left: 110px;
  padding-left: 15px;
  border: 1px solid #e4e7ed;
  background-color: #f5f7fa;
  color: #606266;
  border-radius: 4px;
}

#addSearchList .attributeContentBox .el-button {
  margin: 7px 0;
}

#addSearchList .attributeContentBox .el-button span {
  display: inline;
}

.el-form-item .el-form-item__content .searchTermButton {
  margin-right: 0px;
  border-radius: 20px;
  font-size: 22px;
  padding: 0;
  height: 36px;
  width: 36px;
  background: #fff;
  color: #50b58d;
  margin-left: 20px;
}
.fullSearchButtonBox {
  margin-top: 10px;
  margin-left: 10px;
}
</style>